module.exports = __webpack_public_path__ + "img/origem.958f9f0d.png";